import {Component, FC} from 'react';
import CircleLoader from "react-spinners/CircleLoader";
import { css } from "@emotion/react";

const override: any = css`
  display: block;
  margin: 50px;
`;

function mobile_check(){
    let check = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return check;
};

const PageLoader: FC<any> = ({
    hideText = false
}) => {
    return (
        <div style={
            mobile_check() ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                margin: "200px",
                zoom: "200%",
                fontSize: "20px"
            } :
            {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                margin: "300px"
            }
        }>
            <CircleLoader color={"red"} loading={true} size={50} />
            <br/><br/>
            { !hideText && <p style={ mobile_check() ? {width: "300%", fontSize: "24px"} : {fontSize: "14px"} }>
                Please be patient as the reports are loading. Depending on the data requested, this may take some time.
            </p>
            }
        </div>
    )

}

export default PageLoader;